import React from "react"
import { translate } from "../../translations/translations"
import { useCalculator } from "../../context/CalculatorContext"
import Button from "../Shared/Button"
import { AssetTypes } from "../../models/AssetType"
import styles from "./InputForm.module.css"

interface InfoSectionProps {
  bullets: { title: string; description: string; icon: string }[]
}

const InfoSection: React.FC<InfoSectionProps> = ({ bullets }) => {
  return (
    <section className={styles.infoSection}>
      <div className={styles.introContainer}>
        <ul className={styles.bulletList}>
          {bullets.map((item, idx) => (
            <li key={idx} className={styles.bulletItem}>
              <img src={item.icon} alt="" className={styles.bulletIcon} />
              <div className={styles.bulletTextContainer}>
                <div className={styles.bulletTitle}>{item.title}</div>
                <div
                  className={`${styles.bulletDescription} ${styles.hideOnMobile}`}
                >
                  {item.description}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

interface DropdownProps {
  onSelect: (assetType: string) => void
  selectedAssetType: string
}

const AssetTypeDropdown: React.FC<DropdownProps> = ({
  onSelect,
  selectedAssetType,
}) => {
  return (
    <div className={styles.dropdownContainer}>
      <label htmlFor="assetTypeDropdown" className={styles.dropdownLabel}>
        {translate("select_asset_type")}
      </label>
      <select
        id="assetTypeDropdown"
        className={styles.dropdown}
        onChange={(e) => onSelect(e.target.value)}
        value={selectedAssetType}
      >
        <option value="">{translate("select_placeholder")}</option>
        {AssetTypes.map((type) => (
          <option key={type.key} value={type.key}>
            {translate(type.labelKey)}
          </option>
        ))}
      </select>
    </div>
  )
}

const AssetTypeInput: React.FC<{ onNext: () => void }> = ({ onNext }) => {
  const { shipments, setShipments } = useCalculator()

  const handleSelection = (assetType: string) => {
    setShipments({
      ...shipments,
      assetType,
    })
  }

  const infoBullets = [
    {
      title: translate("slash_costs_title"),
      description: translate("slash_costs_description"),
      icon: "/images/euro.png",
    },
    {
      title: translate("boost_efficiency_title"),
      description: translate("boost_efficiency_description"),
      icon: "/images/lamp.png",
    },
    {
      title: translate("supercharge_satisfaction_title"),
      description: translate("supercharge_satisfaction_description"),
      icon: "/images/hand.png",
    },
  ]

  return (
    <div className={styles.mainContent}>
      <section className={styles.ctaSection}>
        <div className={styles.ctaText}>
          <div>{translate("cta_description1")}</div>
          <div>{translate("cta_description2")}</div>
        </div>
        <div className={styles.inputRow}>
          <AssetTypeDropdown
            onSelect={handleSelection}
            selectedAssetType={shipments.assetType || ""}
          />
          {shipments.assetType && shipments.assetType !== "unknown" && (
            <Button onClick={onNext} label={translate("start")} />
          )}
        </div>
      </section>
      <InfoSection bullets={infoBullets} />
    </div>
  )
}

export default AssetTypeInput
